import { Component } from '@angular/core';

@Component({
	selector: 'warning-sign-img',
	template: require('./warning-sign-img.html')
})
export class WarningSignImgComponent {
	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/components/common/warning-sign-img/warning-sign-img.ts